import web from "@/core/middlewares/web";

let index = () => import(/* webpackChunkName: "success-stories" */ '@/views/success-stories/Index');
let create = () => import(/* webpackChunkName: "success-stories" */ '@/views/success-stories/Create');
let edit = () => import(/* webpackChunkName: "success-stories" */ '@/views/success-stories/Edit');

export default [
    {
        path: "/success-stories",
        name: "success-stories.index",
        component: index,
        meta: {
            middleware: web,
            permissions: ['success-stories:viewAny'],
            title: "داستان های موفقیت"
        }
    },
    {
        path: "/success-stories/create",
        name: "success-stories.create",
        component: create,
        meta: {
            middleware: web,
            permissions: ['success-stories:create'],
            title: "ایجاد داستان موفقیت"
        }
    },
    {
        path: "/success-stories/:id",
        name: "success-stories.edit",
        component: edit,
        meta: {
            middleware: web,
            permissions: ['success-stories:update'],
            title: "ویرایش داستان موفقیت "
        }
    },
]
